/*----- Imports -----*/
import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { css } from 'styled-components'

/*----- Commons-----*/
import Montserrat from '../../commons/mixins/fonts/Montserrat'
import Color from '../../commons/Color'

const handleColorType = color => {
  switch (color) {
    case "success":
      return `background: ${ Color.actions.success }`
    case "danger":
      return `background: ${ Color.actions.danger }`
    default:
      return `background: ${ Color.main }`
  }
};

/*----- Styles-----*/
const StyledHanlderButton = styled.button`
	${ Montserrat(14, 600, 'white') };
	text-transform: capitalize;
	height: 36px;
	border-radius: 4px;
	padding: 0 20px;
	cursor: pointer;
	background: ${Color.main};
	min-width: 160px;
	display: flex;
	justify-content: center;
	align-items: center;
	border: none;
	transition: all 0.3s ease-out;
	&:focus {
		outline: none;
	}
	&:hover {
		color: white;
		box-shadow: 0px 8px 12px 0px rgb(177, 206, 255);
	}

	.default-button__icon {
		width: 16px;
		margin-right: 8px;
	}

  ${props => props.invert && css`
		background: white !important;
		color: ${ Color.main };
		&:hover {
			color: ${ Color.main };
		}
  `}
	${({ type }) => handleColorType(type)};
`

/*----- Component -----*/
const HandlerButton = ({ content, onClick, invert, icon, htmlType, type }) => {
  return(
		<StyledHanlderButton className="handler-button" type={type} htmlType={htmlType} onClick={onClick} invert={invert}>
		{ icon ? <img src={icon} className="default-button__icon" alt={`${content} icon`}/> : null }
		{ content }
		</StyledHanlderButton>
  )
}
export default HandlerButton

/*----- PropTypes -----*/
HandlerButton.propTypes = {
	content:   PropTypes.string.isRequired,
	onClick:   PropTypes.func,
	invert:    PropTypes.bool,
	icon:      PropTypes.string,
	htmlType:  PropTypes.string,
	type:      PropTypes.string
}
